const DEFAULT_SCROLL_PARENT = 'BODY';

function isScrollParent(element) {
  try {
    const { overflow, overflowY, overflowX } = global.getComputedStyle(element);
    return /(auto|scroll)/.test(overflow + overflowX + overflowY);
  } catch (e) {
    return false;
  }
}

export function getScrollParent(element) {
  if (isScrollParent(element)) {
    return element;
  }
  if (!element || element.tagName === DEFAULT_SCROLL_PARENT) {
    return global;
  }
  return getScrollParent(element.parentNode);
}

export function getScrollParents(element, scrollParents = []) {
  if (!element || element.tagName === DEFAULT_SCROLL_PARENT) {
    return [...scrollParents, global];
  }

  return getScrollParents(
    element.parentNode,
    isScrollParent(element) ? [...scrollParents, element] : scrollParents
  );
}
